
import { defineComponent } from 'vue'
import { localeKeys } from '@/libs/locales'

export default defineComponent({
  setup () {
    return {
      localeKeys
    }
  }
})
